import { NodalOfficerDetails as DefaultNodalOfficerDetails } from "src/components/feature/Onboarding";

const NodalOfficerDetails = () => {
  return <DefaultNodalOfficerDetails />;
};

export default NodalOfficerDetails;
